module.exports = __webpack_public_path__ + "img/landing2-b.fa90e3c0.jpg";